import { captureExceptionWithOptions } from '@porterin/component-library/src/ts-utils/analytics/sentry/Sentry';

export enum OrderType {
  OnDemand = 'ondemand',
  Rental = 'rental',
  PNM = 'pnm',
  Courier = 'courier',
  LoadAssist = 'loadassist',
  VehiclePlusLabour = 'vehiclepluslabour',
  BusinessCustomer = 'businesscustomer',
  PartLoad = 'partload',
}

export function fromString(orderType: string): OrderType | null {
  switch (orderType.toLowerCase()) {
    case 'ondemand':
      return OrderType.OnDemand;
    case 'rental':
      return OrderType.Rental;
    case 'pnm':
      return OrderType.PNM;
    case 'courier':
      return OrderType.Courier;
    case 'loadassist':
      return OrderType.LoadAssist;
    case 'vehiclepluslabour':
      return OrderType.VehiclePlusLabour;
    case 'businesscustomer':
      return OrderType.BusinessCustomer;
    case 'partload':
      return OrderType.PartLoad;
    default:
      captureExceptionWithOptions(
        `OrderType.ts: Invalid order type: ${orderType}`,
        {
          'Order_History.invalid_order_type': orderType,
        },
      );
      return null;
  }
}

export function toString(orderType: OrderType): string {
  return orderType;
}
